/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AsyncMenuWithQueryEntrypointProps } from './AsyncMenuWithQuery.entrypoint.types.tsx';
import projectActionsMenuQueryParameters from './__generated__/AsyncMenuWithQueryQuery$parameters';
import type { AsyncMenuWithQueryQuery as TAsyncMenuWithQueryQuery } from './__generated__/AsyncMenuWithQueryQuery.graphql';

type QueryParams = {
	cloudId: string;
	projectKey: string;
};

type ProjectActionMenuEntryPointComponent = EntryPointComponent<
	{
		projectActionMenuQuery: TAsyncMenuWithQueryQuery;
	},
	{},
	AsyncMenuWithQueryEntrypointProps,
	{}
>;

export const projectActionMenuEntryPoint: EntryPoint<
	ProjectActionMenuEntryPointComponent,
	QueryParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectActionMenuEntryPointComponent>(
		/* webpackChunkName: "async-project-actions-menu-content" */ './AsyncMenuWithQuery.tsx',
	),
	getPreloadProps: ({ cloudId, projectKey }: QueryParams) => {
		const projectActionMenuQuery = {
			parameters: projectActionsMenuQueryParameters,
			variables: {
				cloudId,
				projectKey,
				isPlanCreationFromSourceEnabled: expVal(
					'plan_creation_from_other_surface_areas',
					'isEnabled',
					false,
				),
				isSpaceAgentsNonAdminViewEnabled:
					// eslint-disable-next-line jira/ff/no-preconditioning
					fg('space-agent-settings-allow-non-admin-view') &&
					expVal('yamato-agents-home-space-settings-beta', 'isEnabled', false),
			},
			options: {
				fetchPolicy: 'store-and-network' as const,
			},
		};

		return {
			queries: {
				projectActionMenuQuery,
			},
		};
	},
});
